"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.9856 20L9.02693 28.7968C8.85731 29.5586 9.51917 30.2186 10.1646 29.9314L30.4595 20.8984C31.1802 20.5777 31.1802 19.4223 30.4595 19.1016L10.1646 10.0686C9.51917 9.78136 8.85731 10.4414 9.02693 11.2032L10.9856 20ZM12.3165 14.1377L13.4068 19.0347H23.3189L12.3165 14.1377ZM12.3165 25.8623L13.4068 20.9653L23.3189 20.9653L12.3165 25.8623Z", fill: colour })));
};
//# sourceMappingURL=Send.js.map